import * as routes from '../constants/routes'

const initialState = {
    items: [{
        id: 'instructions_framework',
        name: 'Framework',
        link: routes.INSTRUCTIONS_FRAMEWORK,
    }, {
        id: 'source_url',
        name: 'Source URL',
        link: routes.INSTRUCTIONS_FRAMEWORK_URL,
    }],
}

export default function tableOfContentsFramework(state = initialState, action) {
    switch (action.type) {
    default:
        return state
    }
}
